import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { SwProcessingService } from '../services/sw-processing.service';

/**
 * Counts every API call as running work in SwProcessingService, so a new-build
 * update never reloads the page while a request is in flight.
 */
@Injectable()
export class SwProcessingInterceptor implements HttpInterceptor {
  constructor(private swProcessingService: SwProcessingService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.swProcessingService.start();
    return next.handle(req).pipe(
      finalize(() => this.swProcessingService.stop())
    );
  }
}
